import { Link } from "react-router-dom";
import { Seo } from "@/site/seo";
import { Heading } from "@/site/components/Section";
import { publishedArticles, pillar, AUTHOR } from "@/site/articles";
import { fmtDate } from "@/site/api";
import { SITE } from "@/site/content";

export default function BlogPage() {
  const posts = publishedArticles();
  const hub = pillar();
  const rest = posts.filter((p) => !p.pillar);
  const ld = {
    "@context": "https://schema.org", "@type": "Blog", name: `${SITE.name} blog`, url: `${SITE.url}/blog`,
    author: { "@type": "Organization", name: SITE.name },
    blogPost: posts.map((p) => ({ "@type": "BlogPosting", headline: p.title, datePublished: p.date, url: `${SITE.url}/blog/${p.slug}`, author: { "@type": "Organization", name: AUTHOR } })),
  };
  return (
    <>
      <Seo title="Blog — expansion revenue, account management and governance" description="Essays from Team Postern on expansion revenue, the CSM/AM split, account whitespace, and why discount approval policies stop being binding. No listicles, no fake statistics." path="/blog" jsonLd={ld} />
      <section className="section">
        <div className="wrap" style={{ maxWidth: 880 }}>
          <Heading eyebrow="Blog" title="Expansion, account management and governance, argued properly." lede="Long-form, opinionated, and written by the people building the product. Where a number matters we cite a public source or say it is our experience. New post most weeks." />
          <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 28, fontSize: 13, color: "var(--muted)" }}>
            <span className="mono">{posts.length} post{posts.length === 1 ? "" : "s"}</span>
            <span aria-hidden="true">·</span>
            <Link to="/blog/subscribe" className="mono" data-testid="blog-rss">Subscribe <span style={{ color: "var(--faint)" }}>· RSS, Slack, feed readers</span></Link>
          </div>

          {hub && (
            <Link to={`/blog/${hub.slug}`} className="post post--pillar" data-testid={`post-card-${hub.slug}`}>
              <div className="post__meta"><span className="status status--today">Start here</span><span>{fmtDate(hub.date)} · {hub.minutes} min read</span></div>
              <h2 className="post__title">{hub.title}</h2>
              <p className="post__desc">{hub.description}</p>
              <span className="post__more">Read the pillar piece →</span>
            </Link>
          )}

          <div className="post-list" data-testid="post-list">
            {rest.map((p) => (
              <Link key={p.slug} to={`/blog/${p.slug}`} className="post" data-testid={`post-card-${p.slug}`}>
                <div className="post__meta"><span>{fmtDate(p.date)}</span><span>·</span><span>{p.minutes} min read</span>{p.tags[0] && <><span>·</span><span>{p.tags[0]}</span></>}</div>
                <h2 className="post__title">{p.title}</h2>
                <p className="post__desc">{p.description}</p>
              </Link>
            ))}
          </div>
          {posts.length === 0 && <div className="card" style={{ color: "var(--muted)" }} data-testid="writing-empty">Nothing published yet.</div>}
        </div>
      </section>
    </>
  );
}
